<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
  <div class="container">
  <a class="navbar-brand d-flex align-items-center text-white" routerLink="home">
    <img src="assets/logo/JFWhiteLogo.svg" height="30" class="mr-2" alt="" loading="lazy">
    Jindal Forging Pvt Ltd
  </a>
    <button (click)="toggleCollapse()" class="navbar-toggler border-0 float-right" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse justify-content-end" [class]="collapse? 'collapse': ''">
      <ul class="navbar-nav float-right">
        <li *ngFor="let link of links" class="nav-item">
          <a class="nav-link" routerLinkActive="active" [routerLink]="link.route">{{link.label}}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
